/**
 * @module tab/tabcommand
 */

import { Command } from 'ckeditor5/src/core';

/**
 * Tab command. It is used by the {@link module:tab/tab~Tab Tab feature} to handle the <kbd>Tab</kbd> key.
 *
 * @extends {Command}
 */
export default class TabCommand extends Command {
	/**
	 * @inheritDoc
	 */
	execute() {
		const model = this.editor.model;
		const doc = model.document;

		model.change( writer => {
			if ( !doc.selection.isCollapsed ) {
				model.deleteContent( doc.selection );
			}
			writer.insertElement( 'tab', doc.selection.getAttributes(), doc.selection.getFirstPosition() );
		} );
	}
}
